import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.571 13.857H3.43a1.42 1.42 0 0 1-1.018-.39A1.28 1.28 0 0 1 2 12.5q0-.577.41-.967a1.42 1.42 0 0 1 1.019-.39h7.142V4.357q0-.577.411-.967Q11.392 3 12 3c.608 0 .744.13 1.018.39s.41.583.41.967v6.786h7.143q.607 0 1.018.39c.411.39.411.583.411.967s-.137.707-.41.967a1.42 1.42 0 0 1-1.019.39H13.43v6.786q0 .577-.411.967-.41.39-1.018.39c-.608 0-.744-.13-1.018-.39a1.28 1.28 0 0 1-.41-.967v-6.786Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }